import {
  downloadManualLogging,
  manualLoggingActivation,
  manualLoggingSubmissionApprove,
  manualLoggingSubmissionProcess,
  manualLoggingSubmissionReject,
  postAutoApprove,
  settingManualActivation
} from '../../utils/api';
import { FAILED, LOADING, SET_DATA, SUCCESS } from './constants';

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}

export function setData(data, key) {
  return { type: SET_DATA, data, key };
}

export function fetchManualLoggings(params = {}) {
  return async (dispatch, getState) => {
    const { totalPage } = getState().manualLoggingActivation.dataManualLoggingActivation.meta;

    let dataList  = [];
    if (params.page > 1 && params.page > totalPage) {
      return;
    }else{
      const key = 'ManualLoggingActivation';
      try {
        if (params?.page !== 1 && params?.page !== '1') {
          // dispatch(successAction({ data : [] }, key));
          dataList = getState().manualLoggingActivation.dataManualLoggingActivation.data;
        }

        dispatch(loadingAction(true, key));
        const requestParams = {
          ...params,
          size: 100,
        };
        let { data, meta } = await manualLoggingActivation(requestParams);

        dispatch(setData({ data: [ ...dataList, ...data] , meta }, key));
      } catch (error) {
        dispatch(failedAction(error.message, key));
      }
    }
  };
}

export function fetchSettingManualActivation(params = {}) {
  return async (dispatch, getState) => {
    const { totalPage } = getState().manualLoggingActivation.dataSettingManualActivation.meta;

    let dataList  = [];
    if (params.page > 1 && params.page > totalPage) {
      return;
    }else{
      const key = 'SettingManualActivation';
      try {
        if (params?.page !== 1 && params?.page !== '1') {
          // dispatch(successAction({ data : [] }, key));
          dataList = getState().manualLoggingActivation.dataSettingManualActivation.data;
        }

        dispatch(loadingAction(true, key));
        const requestParams = {
          ...params,
          size: 100,
        };
        const { data, meta } = await settingManualActivation(requestParams);

        dispatch(setData({ data: [ ...dataList, ...data] , meta }, key));
      } catch (error) {
        dispatch(failedAction(error.message, key));
      }
    }
  };
}

export function fetchDownload(params) {
  return async (dispatch) => {
    const key = 'Download';

    try {
      dispatch(loadingAction(true, key));
      const { data } = await downloadManualLogging(params);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
}

export function seterrorUnduh() {
  return async (dispatch) => {
    const key = 'ErrorUnduh';
    dispatch(loadingAction(true, key));
    setTimeout(() => {
      dispatch(failedAction(true, key));
      dispatch(loadingAction(false, key));
    });
  };
}


export function setManualLoggingFilter(filter) {
  return async (dispatch) => {
    dispatch(successAction(filter, 'Filter'));
  };
}

export function setSettingManualLoggingFilter(filter){
  return async (dispatch) => {
    dispatch(successAction(filter, 'FilterSetting'));
  };
}

export const submitAutoApprove = (payload, areaName = 'all', callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmitAutoApprove';
    dispatch(loadingAction(true, key));
    callback();
    try {
      await postAutoApprove(payload);
      dispatch(successAction(areaName, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submissionProses = (payload, isReject, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmissionProses';
    dispatch(loadingAction(true, key));
    callback();
    try {
      const data = await manualLoggingSubmissionProcess({ requestId: payload.requestId });
      const dataPayload = { ...payload, ...{ isReject } };
      dispatch(successAction({ response: data, data : dataPayload }, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submissionOnProses = (payload, isReject) => {
  return async (dispatch) => {
    const key = 'SubmissionProses';
    const data = { ...payload, ...{ isReject } };
    dispatch(successAction({ response: { code : 200 }, data }, key));
  };
};

export const submitApprove = (payload, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmissionApprove';
    dispatch(loadingAction(true, key));
    callback();
    try {
      const data = await manualLoggingSubmissionApprove(payload);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitReject = (payload, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmissionReject';
    dispatch(loadingAction(true, key));
    callback();
    try {
      const data = await manualLoggingSubmissionReject(payload);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};
